module.exports = __webpack_public_path__ + "static/img/16.7f7faef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u_img/16.png
// module id = fRXs
// module chunks = 2